import React, { useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { sendContactRequest } from '../helpers/apiHelper';
import '../styles/SupportForm.css';
import { useAuth } from '../context/AuthContext';

export const MESSAGE_MAX_LENGTH = 5000;

const SupportForm = () => {
  const { t } = useTranslation();
  const { tokens } = useAuth();

  const [enquiryType, setEnquiryType] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);

  const enquiryOptions = ['option1', 'option2'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const enquiryTypeLabel = enquiryType ? t(`supportForm.${enquiryType}`) : '';

    setErrors([]);
    setIsSubmitting(true);
    try {
      await sendContactRequest(
        { enquiryType: (enquiryTypeLabel || enquiryType).slice(0, 100), message },
        tokens?.idToken,
      );
      setSubmitted(true);
    } catch (error) {
      const fieldMessages =
        error?.status === 400 ? Object.values(error.fieldErrors || {}).filter(Boolean) : [];
      setErrors(fieldMessages.length ? fieldMessages : [t('supportForm.send_error')]);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="support-form">
        <h2>{t('supportForm.thank_you_title')}</h2>
        <p>{t('supportForm.thank_you_message')}</p>
      </div>
    );
  }

  return (
    <form className="support-form" onSubmit={handleSubmit}>
      <h2>{t('supportForm.title')}</h2>

      <div className="form-group">
        <label htmlFor="enquiryType">
          {t('supportForm.enquiry_type_label')}
        </label>
        <select
          id="enquiryType"
          value={enquiryType}
          onChange={(e) => setEnquiryType(e.target.value)}
          required
        >
          <option value="">
            {t('supportForm.enquiry_type_placeholder')}
          </option>

          {enquiryOptions.map((key) => (
            <option key={key} value={key}>
              {t(`supportForm.${key}`)}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="message">
          {t('supportForm.message_label')}
        </label>
        <textarea
          id="message"
          rows="5"
          value={message}
          placeholder={t('supportForm.message_placeholder')}
          onChange={(e) => setMessage(e.target.value)}
          maxLength={MESSAGE_MAX_LENGTH}
          required
        />
      </div>

      {errors.length > 0 && (
        <div className="support-form-error" role="alert">
          {errors.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
      )}

      <div className="modal-buttons">
        <button
          type="submit"
          className="modal-button update"
          disabled={!enquiryType || !message || isSubmitting}
        >
          {isSubmitting ? t('updating') : t('supportForm.submit_button')}
        </button>
      </div>
    </form>
  );
};

export default SupportForm;
